import { signOut } from "@aws-amplify/auth";
import { Amplify } from "aws-amplify";
import { useCallback, useEffect, useState } from "react";
import { IoIosLogOut } from "react-icons/io";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import amplifyconfig from "../../amplifyconfiguration.json";
import bot from "../../assets/bot.png";
import loadingIcon from "../../assets/loader.svg";
import send from "../../assets/send.svg";
import user from "../../assets/user.png";
import Api from "../../services/Api";
import { LoadingInline } from "../LoadingInline";
import "./index.css";
import { useAuthentication } from "../../hooks/useAuthentication";
import { CiEdit } from "react-icons/ci";

Amplify.configure(amplifyconfig);

function ChatbotPage() {
  const [input, setInput] = useState("");
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [signOutLoading, setSignOutLoading] = useState(false);
  const { isMaster, userId } = useAuthentication();

  useEffect(() => {
    document.querySelector(".layout").scrollTop =
      document.querySelector(".layout").scrollHeight;
  }, [posts]);

  const { data, isLoading } = useQuery(["messages", userId], async () => {
    const response = await Api.get("/chatbot");
    return response.messages;
  });

  useEffect(() => {
    if (data) {
      setPosts(
        data.flatMap((message) => [
          {
            type: "user",
            post: message.input,
          },
          {
            type: "bot",
            post: message.response,
          },
        ])
      );
    }
  }, [data]);

  const fetchBotResponse = useCallback(async () => {
    const response = await Api.post("/chatbot", {
      body: { message: input },
    });
    return {
      bot: response.data.content,
    };
  }, [input]);

  const autoTypingBotResponse = useCallback((text) => {
    setPosts((prevState) => {
      const lastItem = prevState[prevState.length - 1];
      if (lastItem.type === "loading") {
        prevState.pop();
      }
      if (lastItem.type !== "bot") {
        prevState.push({
          type: "bot",
          post: text,
        });
      } else {
        lastItem.post = text;
      }
      return [...prevState];
    });
  }, []);

  const updatePosts = useCallback(
    (post, isBot, isLoading) => {
      if (isBot) {
        autoTypingBotResponse(post);
      } else {
        setPosts((prevState) => {
          return [
            ...prevState,
            {
              type: isLoading ? "loading" : "user",
              post,
            },
          ];
        });
      }
    },
    [autoTypingBotResponse]
  );

  const onSubmit = useCallback(() => {
    if (input.trim() === "") return;
    updatePosts(input);
    updatePosts("loading...", false, true);
    setInput("");
    fetchBotResponse()
      .then((res) => {
        updatePosts(res.bot.trim(), true);
      })
      .catch((err) => {
        setError(`Erro ao buscar mensagem do chatbot`);
      });
  }, [input, updatePosts, fetchBotResponse]);

  const onKeyUp = useCallback(
    (e) => {
      if (e.key === "Enter" || e.which === 13) {
        onSubmit();
      }
    },
    [onSubmit]
  );

  const handleSignOut = useCallback(async () => {
    setSignOutLoading(true);
    await signOut();
    setSignOutLoading(false);
    navigate("/login");
  }, [navigate]);

  const handleEditChat = useCallback(async () => {
    navigate("/chatbot/edit");
  }, [navigate]);

  return (
    <main className="chatGPT-app">
      <div className="buttons-container">
        {isMaster && (
          <button
            className="header-button edit-chat-button"
            onClick={handleEditChat}
          >
            <CiEdit size={23} />
          </button>
        )}
        <button className="header-button sign-out" onClick={handleSignOut}>
          {signOutLoading ? <LoadingInline /> : <IoIosLogOut size={23} />}
        </button>
      </div>
      <section className="chat-container">
        <div className="layout">
          {error && <h2> {error}</h2>}
          {isLoading && <LoadingInline />}
          {!isLoading &&
            posts.map((post, index) => (
              <div
                key={index}
                className={`chat-bubble ${
                  post.type === "bot" || post.type === "loading" ? "bot" : ""
                }`}
              >
                <div className="avatar">
                  <img
                    alt=""
                    src={
                      post.type === "bot" || post.type === "loading"
                        ? bot
                        : user
                    }
                  />
                </div>
                {post.type === "loading" ? (
                  <div className="loader">
                    <img src={loadingIcon} alt="Carregando" />
                  </div>
                ) : (
                  <div className="post">{post.post}</div>
                )}
              </div>
            ))}
        </div>
      </section>
      <footer>
        <input
          className="composebar"
          value={input}
          autoFocus
          type="text"
          placeholder="Escreva aqui sua pergunta!"
          onChange={(e) => setInput(e.target.value)}
          onKeyUp={onKeyUp}
        />
        <div className="send-button" onClick={onSubmit}>
          <img src={send} alt="Enviando" />
        </div>
      </footer>
    </main>
  );
}

export default ChatbotPage;
